import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2 } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SharedService {
  private links: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  private isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private navigating: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private tags: BehaviorSubject<HTMLMetaElement[]> = new BehaviorSubject<HTMLMetaElement[]>([]);
  private posIdSubject = new BehaviorSubject<string>('');
  protected renderer: Renderer2;
  @Inject(DOCUMENT) protected document: Document;
  posId$ = this.posIdSubject.asObservable();

  setPosId(posId: string) {
    this.posIdSubject.next(posId);
  }
  get isLoading$(): Observable<boolean> {
    return this.isLoading.asObservable();
  }
  set isLoading$(value: any) {
    this.isLoading.next(value);
  }
  get navigating$(): Observable<boolean> {
    return this.navigating.asObservable();
  }
  set navigating$(value: any) {
    this.navigating.next(value);
  }
  get links$(): Observable<any[]> {
    return this.links.asObservable();
  }
  set links$(value: any) {
    this.links.next(value);
  }
  get tags$(): Observable<HTMLMetaElement[]> {
    return this.tags.asObservable();
  }
  set tags$(value: any) {
    this.tags.next(value);
  }
}
